import React, { useEffect } from 'react'

import { GetServerSidePropsContext } from 'next'
import Link from 'next/link'
import styled from 'styled-components/macro'
import { connect, useDispatch } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'

import { ProductView } from '@/components/Product/ProductView'
import { Text } from '@/components/Text'
import { ProductArea } from '@/components/ProductArea'
import { PageLayout } from '@/components/Layout/PageLayout'
import { Path } from '@/components/Path'

import { initializeStore } from '@/redux/store'
import { getProducts, getSettings } from '@/redux/actions'

import { ColorsMap } from '@/utils/Theme'
import { Cookie, retrieve } from '@/utils/Helpers'

const Main = styled.div`
  padding-bottom: 3rem;
`

const Wrapper = styled.div`
  background-color: ${ColorsMap.white};
  width: 100%;
`

const ProductAreaWrapper = styled.div`
  margin: 0 auto;
  padding: 2.5rem 10%;
  max-width: 1500px;
`
export const StyledPath = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 1rem;
`
export const SubLink = styled.a`
  color: ${ColorsMap.textDefault};
  align-self: flex-end;
  margin-bottom: 0.4rem;
  &:hover {
    color: ${ColorsMap.brownishGrey};
  }
`

const ProductPage = (props) => {
  const { t } = useTranslation('common')

  const dispatch = useDispatch()

  Cookie.set('prevPageProduct', true, 1)

  useEffect(() => {
    dispatch(getProducts({ token: Cookie.text('token') || null }))
  }, [])

  const productview = () => {
    return (
      <Main>
        <ProductView product={props.item} currency={props.state.settings.currency.symbol} />
        <Wrapper>
          <ProductAreaWrapper>
            <StyledPath>
              <Text textColor={ColorsMap.primary} fontSize="xl" fontWeight="bold" mr="1.5rem">
                {t('related-products-title')}
              </Text>
              <Link href="/products" passHref>
                <SubLink>{t('see-all')}</SubLink>
              </Link>
            </StyledPath>
            <ProductArea variant="slider" products={props.state.products.payload} shouldFetch={false} />
          </ProductAreaWrapper>
        </Wrapper>
      </Main>
    )
  }

  return (
    <PageLayout title={`${props.item.name} | ${props.state.settings.name}`} secondary HeaderbackgroundGrey>
      <Path
        pathLinks={[
          <Link as={`/brand/${props.item.brand.slug}`} href="/brand/[brand]">
            {props.item.brand.name}
          </Link>,
          <Link
            href={`/brand/[brand]?category=${props.item.categories[0].slug}`}
            as={`/brand/${props.item.brand.slug}?category=${props.item.categories[0].slug}`}
          >
            {props.item.categories[0].name}
          </Link>,
          <span>{props.item.name}</span>,
        ]}
      />
      {productview()}
    </PageLayout>
  )
}

const mapStateToProps = (state: { state: object }) => ({
  state,
})

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const reduxStore = initializeStore({})
  const { dispatch } = reduxStore

  await dispatch(getSettings({}))

  let error = false
  const item = await retrieve(`api/product?slug=${ctx.query.slug}`, 'GET')
    .then((res) => res.json())
    .then((res) => {
      if (res.data == undefined) {
        throw Error('')
      }
      return res.data
    })
    .catch((e) => {
      error = true
    })

  if (error) {
    return { notFound: true }
  }

  return { props: { initialReduxState: reduxStore.getState(), item } }
}

export default connect(mapStateToProps)(ProductPage)

